import React from 'react';
import { UsersIcon, BarChart3Icon, FileTextIcon, CogIcon, ShoppingCartIcon } from 'lucide-react';
const VerticalCard = ({
  icon,
  title,
  description
}) => {
  return <div className="bg-white p-6 rounded-lg shadow-md hover:shadow-xl transition-all duration-300 border-2 border-gray-200 hover:border-indigo-300" data-id="element-237">
      <div className="w-12 h-12 bg-indigo-600 rounded-lg flex items-center justify-center text-white mb-4" data-id="element-238">
        {icon}
      </div>
      <h3 className="text-xl font-semibold text-gray-900 mb-2" data-id="element-239">{title}</h3>
      <p className="text-gray-700" data-id="element-240">{description}</p>
    </div>;
};
export const VerticalsSection = () => {
  const verticals = [{
    icon: <UsersIcon size={24} data-id="element-241" />,
    title: 'HR',
    description: 'Streamline recruitment, automate employee onboarding, and enhance talent management with AI-powered insights.'
  }, {
    icon: <BarChart3Icon size={24} data-id="element-242" />,
    title: 'Finance',
    description: 'Leverage AI for predictive financial modeling, fraud detection, and automated financial reporting.'
  }, {
    icon: <FileTextIcon size={24} data-id="element-243" />,
    title: 'Accounting',
    description: 'Automate invoice processing, expense categorization, and financial reconciliation with intelligent systems.'
  }, {
    icon: <CogIcon size={24} data-id="element-244" />,
    title: 'Operations',
    description: 'Optimize workflows, predict maintenance needs, and enhance operational efficiency through AI analytics.'
  }, {
    icon: <ShoppingCartIcon size={24} data-id="element-245" />,
    title: 'Vendors',
    description: 'Improve vendor selection, automate procurement processes, and optimize supply chain management.'
  }];
  return <section id="verticals" className="w-full py-16 bg-white border-b border-gray-200" data-id="element-246">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-247">
        <div className="text-center mb-12" data-id="element-248">
          <h2 className="text-3xl font-bold text-gray-900" data-id="element-249">
            AI Integration Across All Verticals
          </h2>
          <p className="mt-4 text-xl text-gray-700 max-w-3xl mx-auto" data-id="element-250">
            Our platform seamlessly connects with every department of your
            enterprise, enhancing productivity and driving innovation.
          </p>
        </div>
        <div className="mb-16 flex justify-center" data-id="element-251">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/bHhcZhxDTvRViJByhWhLwu/AI_Integration_Graphic_Design.png" alt="AI Integration across all verticals - HR, Finance, Accounting, Operations, and Vendors connected through AI Core Intelligence Hub" className="w-full max-w-4xl rounded-lg shadow-2xl border-2 border-gray-200" data-id="element-252" />
        </div>
      </div>
    </section>;
};